export default {"src":"/_next/static/media/Laybuy-Logo-Black-grape.64359c3c.svg","height":130,"width":576,"blurWidth":0,"blurHeight":0};